import type { Rule } from '@/plugins/casl/ability'

export const formatUserFunctionalityRules = () => {
  const userFunctionalityRules = useCookie<{ [key: string]: string[] }>(
    'userAbilityRules',
  )

  const userAbilityRules: Rule[] = []

  if (userFunctionalityRules.value) {
    for (const [key, actions] of Object.entries(userFunctionalityRules.value)) {
      actions.forEach((action: string) => {
        userAbilityRules.push({
          action: action.toString(),
          subject: key.toString(),
        })
      })
    }
  }

  return userAbilityRules
}
